// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"18":"7b879c30","215":"a0384997","872":"cf53374e"}[chunkId] + ".js";
};